(function ($) {
    'use strict';

    var DRAWER_TRANSITION_MS = 350;

    function initTooltips($root) {
        if (typeof bootstrap === 'undefined' || !bootstrap.Tooltip) {
            return;
        }

        $root.find('[data-bs-toggle="tooltip"]').each(function () {
            bootstrap.Tooltip.getOrCreateInstance(this);
        });
    }

    function getDrawer($root) {
        return $root.find('.archive-filters-drawer').first();
    }

    function openDrawer($root) {
        var $drawer = getDrawer($root);
        if (!$drawer.length || $drawer.hasClass('is-open')) {
            return;
        }

        $drawer.removeAttr('hidden').attr('aria-hidden', 'false');
        $root.find('[data-archive-filters-open]').attr('aria-expanded', 'true');
        $('body').addClass('archive-filters-open');

        // Paint the closed state before animating open.
        void $drawer[0].offsetHeight;

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                $drawer.addClass('is-open');
            });
        });
    }

    function closeDrawer($root) {
        var $drawer = getDrawer($root);
        if (!$drawer.length || !$drawer.hasClass('is-open')) {
            return;
        }

        $drawer.removeClass('is-open').attr('aria-hidden', 'true');
        $root.find('[data-archive-filters-open]').attr('aria-expanded', 'false');
        $('body').removeClass('archive-filters-open');

        window.setTimeout(function () {
            if (!$drawer.hasClass('is-open')) {
                $drawer.attr('hidden', 'hidden');
            }
        }, DRAWER_TRANSITION_MS);
    }

    function syncDrawerFromSidebar($root) {
        var $sidebarForm = $root.find('#archive-filters-sidebar');
        var $drawerForm = $root.find('.archive-filters-form--drawer');

        if (!$sidebarForm.length || !$drawerForm.length) {
            return;
        }

        $drawerForm.find('input[name="s"]').val($sidebarForm.find('input[name="s"]').val());

        $drawerForm.find('input[type="checkbox"], input[type="radio"]').each(function () {
            var $input = $(this);
            var name = $input.attr('name');
            var value = $input.val();
            var $source = $sidebarForm.find('[name="' + name + '"][value="' + value + '"]');
            $input.prop('checked', $source.is(':checked'));
        });

        $drawerForm.find('input[type="range"]').each(function () {
            var $input = $(this);
            var name = $input.attr('name');
            var $source = $sidebarForm.find('[name="' + name + '"]');
            if ($source.length) {
                $input.val($source.val()).trigger('input');
            }
        });
    }

    function updateAdvancedSearchBounds($root) {
        var $contentCol = $root.find('.content-col').first();

        if (!$contentCol.length) {
            return;
        }

        var rect = $contentCol[0].getBoundingClientRect();

        $root.css({
            '--archive-advanced-left': rect.left + 'px',
            '--archive-advanced-width': rect.width + 'px'
        });
    }

    function isDesktopArchiveFilters() {
        if (window.ThemeJS && ThemeJS.Media_Queries && typeof ThemeJS.Media_Queries.is_at_least === 'function') {
            return ThemeJS.Media_Queries.is_at_least('lg');
        }

        return window.matchMedia('(min-width: 992px)').matches;
    }

    function getAdvancedFocusTrap($root) {
        var existingTrap = $root.data('archiveAdvancedFocusTrap');
        var $panel = $root.find('[data-archive-advanced-search]').first();

        if (existingTrap || !window.focusTrap || !$panel.length) {
            return existingTrap || null;
        }

        existingTrap = focusTrap.createFocusTrap($panel.get(0), {
            allowOutsideClick: function (event) {
                return isDesktopArchiveFilters() && event.target.closest('header');
            },
            clickOutsideDeactivates: false,
            escapeDeactivates: false,
            fallbackFocus: $panel.get(0),
            initialFocus: $panel.find('[data-archive-advanced-close]').get(0) || $panel.get(0),
            returnFocusOnDeactivate: true,
            setReturnFocus: function () {
                return $root.find('[data-archive-advanced-open]').get(0) || false;
            }
        });

        $root.data('archiveAdvancedFocusTrap', existingTrap);

        return existingTrap;
    }

    function openAdvancedSearch($root) {
        var $panel = $root.find('[data-archive-advanced-search]').first();
        var focusTrapInstance;
        if (!$panel.length) {
            return;
        }

        updateAdvancedSearchBounds($root);
        $panel.removeAttr('hidden').attr('aria-hidden', 'false');
        $root.addClass('archive-advanced-search-open');
        $root.find('.sidebar-col').attr('aria-hidden', 'true');

        requestAnimationFrame(function () {
            $('body').addClass('archive-advanced-search-open');
            $panel.addClass('is-open');
            focusTrapInstance = getAdvancedFocusTrap($root);

            if (focusTrapInstance) {
                focusTrapInstance.activate();
            }
        });
    }

    function closeAdvancedSearch($root, returnFocus) {
        var $panel = $root.find('[data-archive-advanced-search]').first();
        var focusTrapInstance = $root.data('archiveAdvancedFocusTrap');
        if (!$panel.length) {
            return;
        }

        if (focusTrapInstance) {
            focusTrapInstance.deactivate({
                returnFocus: returnFocus !== false
            });
        }

        $panel.removeClass('is-open').attr('aria-hidden', 'true');
        $root.removeClass('archive-advanced-search-open');
        $('body').removeClass('archive-advanced-search-open');
        $root.find('.sidebar-col').removeAttr('aria-hidden');

        window.setTimeout(function () {
            if (!$panel.hasClass('is-open')) {
                $panel.attr('hidden', 'hidden');
            }
        }, 200);
    }

    function handleArchiveFilterResize($root) {
        if (!$root.hasClass('archive-advanced-search-open')) {
            return;
        }

        if (!isDesktopArchiveFilters()) {
            closeAdvancedSearch($root, false);
            return;
        }

        updateAdvancedSearchBounds($root);
    }

    function updateRangeLabels($range) {
        var $min = $range.find('[data-archive-range-min]');
        var $max = $range.find('[data-archive-range-max]');
        var labels = $range.data('archive-range-labels') || {};
        var min = parseInt($min.val(), 10);
        var max = parseInt($max.val(), 10);
        var floor = parseInt($min.attr('min'), 10);
        var ceiling = parseInt($min.attr('max'), 10);
        var size = Math.max(1, ceiling - floor);
        var negativePrefix = String($range.data('archive-range-negative-prefix') || '');

        function formatRangeLabel(value) {
            if (Object.prototype.hasOwnProperty.call(labels, value)) {
                return labels[value];
            }

            if (negativePrefix && value < 0) {
                return negativePrefix + Math.abs(value);
            }

            return value;
        }

        if (min > max) {
            if ($(document.activeElement).is($min)) {
                max = min;
                $max.val(max);
            } else {
                min = max;
                $min.val(min);
            }
        }

        $range.find('[data-archive-range-min-label]').text(formatRangeLabel(min));
        $range.find('[data-archive-range-max-label]').text(formatRangeLabel(max));
        $range.css({
            '--range-lower-pos': ((min - floor) / size * 100) + '%',
            '--range-upper-pos': ((max - floor) / size * 100) + '%'
        });
    }

    function archiveFormHasActiveFilters($form) {
        var hasActiveFilters = false;

        $form.find('input, select, textarea').each(function () {
            var input = this;
            var $input = $(input);
            var type = ($input.attr('type') || input.tagName).toLowerCase();
            var name = $input.attr('name') || '';

            if (!name || type === 'hidden' || type === 'submit' || type === 'button') {
                return;
            }

            if (type === 'checkbox') {
                if (input.checked) {
                    hasActiveFilters = true;
                    return false;
                }

                return;
            }

            if (type === 'radio') {
                if (input.checked && input.value !== 'date-desc') {
                    hasActiveFilters = true;
                    return false;
                }

                return;
            }

            if (type === 'range') {
                var min = $input.attr('min');
                var max = $input.attr('max');

                if ((name.slice(-4) === '_min' && input.value !== min) || (name.slice(-4) === '_max' && input.value !== max)) {
                    hasActiveFilters = true;
                    return false;
                }

                return;
            }

            if ($.trim($input.val() || '') !== '') {
                hasActiveFilters = true;
                return false;
            }
        });

        return hasActiveFilters;
    }

    function getFormValues($form) {
        var values = {};

        $form.find('input, select, textarea').each(function () {
            var input = this;
            var $input = $(input);
            var type = ($input.attr('type') || input.tagName).toLowerCase();
            var name = $input.attr('name') || '';

            if (!name || type === 'hidden' || type === 'submit' || type === 'button') {
                return;
            }

            if ((type === 'checkbox' || type === 'radio') && !input.checked) {
                return;
            }

            values[name] = values[name] || [];
            values[name].push(String($input.val() || ''));
        });

        return values;
    }

    function getUrlValuesForForm($form) {
        var values = {};
        var params = new URLSearchParams(window.location.search);

        $form.find('input, select, textarea').each(function () {
            var input = this;
            var $input = $(input);
            var type = ($input.attr('type') || input.tagName).toLowerCase();
            var name = $input.attr('name') || '';

            if (!name || type === 'hidden' || type === 'submit' || type === 'button' || values[name]) {
                return;
            }

            var paramName = name.slice(-2) === '[]' ? name.slice(0, -2) : name;
            var paramValues = params.getAll(paramName).concat(params.getAll(name));

            if (paramValues.length) {
                values[name] = paramValues.map(function (value) {
                    return String(value);
                });
            }
        });

        return values;
    }

    function normalizeValueMap(values) {
        var normalized = {};

        Object.keys(values).forEach(function (name) {
            normalized[name] = values[name].slice().sort();
        });

        return normalized;
    }

    function valueMapsDiffer(a, b) {
        a = normalizeValueMap(a);
        b = normalizeValueMap(b);

        var names = Object.keys(a).concat(Object.keys(b)).filter(function (name, index, allNames) {
            return allNames.indexOf(name) === index;
        });

        return names.some(function (name) {
            var aValues = a[name] || [];
            var bValues = b[name] || [];

            if (aValues.length !== bValues.length) {
                return true;
            }

            return aValues.some(function (value, index) {
                return value !== bValues[index];
            });
        });
    }

    function archiveFormDiffersFromUrl($form) {
        var formValues = getFormValues($form);
        var urlValues = getUrlValuesForForm($form);
        var urlNames = Object.keys(urlValues);

        if (!urlNames.length) {
            return false;
        }

        var comparableFormValues = {};

        urlNames.forEach(function (name) {
            if (formValues[name]) {
                comparableFormValues[name] = formValues[name];
            }
        });

        return valueMapsDiffer(comparableFormValues, urlValues);
    }

    function updateArchiveApplyButton($form) {
        if (!$form.length || !$form.attr('id')) {
            return;
        }

        $('[form="' + $form.attr('id') + '"].sidebar-filters__apply').prop('disabled', !archiveFormHasActiveFilters($form) && !archiveFormDiffersFromUrl($form));
    }

    $(function () {
        $('[data-archive-filters]').each(function () {
            var $root = $(this);

            initTooltips($root);

            $root.on('click', '[data-archive-filters-open]', function () {
                syncDrawerFromSidebar($root);
                initTooltips($root);
                openDrawer($root);
            });

            $root.on('click', '[data-archive-filters-close]', function () {
                closeDrawer($root);
            });

            $root.on('click', '[data-archive-advanced-open]', function () {
                window.scrollTo(0, 0);
                openAdvancedSearch($root);
            });

            $root.on('click', '[data-archive-advanced-close]', function () {
                closeAdvancedSearch($root);
            });

            $(window).on('resize breakpoint_changed', function () {
                handleArchiveFilterResize($root);
            });

            $(document).on('keydown', function (event) {
                if (event.key === 'Escape') {
                    closeDrawer($root);
                    closeAdvancedSearch($root);
                }
            });

            $root.on('change', '[data-archive-product-sort] select', function () {
                var url = new URL(window.location.href);
                var sort = $(this).val();

                if (sort && sort !== 'relevance') {
                    url.searchParams.set('product_sort', sort);
                } else {
                    url.searchParams.delete('product_sort');
                }

                window.location.assign(url.toString());
            });

            $root.on('change', '[data-archive-filters-auto-submit] input[type="checkbox"], [data-archive-filters-auto-submit] input[type="radio"]', function () {
                $(this).closest('form').submit();
            });

            $root.on('keydown', '.archive-filter-toggle input[type="checkbox"]', function (event) {
                if (event.key !== 'Enter') {
                    return;
                }

                event.preventDefault();
                $(this).trigger('click');
            });

            $root.on('change', '[data-archive-filters-auto-submit] [data-archive-range] input[type="range"]', function () {
                $(this).closest('form').submit();
            });

            $root.on('input change', '[data-archive-range] input[type="range"]', function () {
                updateRangeLabels($(this).closest('[data-archive-range]'));
            });

            $root.on('input change', '#archive-filters-sidebar input, #archive-filters-sidebar select, #archive-filters-sidebar textarea', function () {
                updateArchiveApplyButton($(this).closest('form'));
            });
        });
    });
})(jQuery);
